<!-- Popup Modal -->
<div class="modal-overlay" *ngIf="isPopupOpen">
  <div class="modal-content">
    <button class="btn btn-danger btn-icon close-btn" (click)="closePopup()">
      <i class="far fa-window-close"></i>
    </button>
    <div class="scan-box"></div>
    <div class="scan-box-title">بارکد را اینجا قرار دهید</div>
    <video #videoElement autoplay></video>
  </div>
</div>
